const hexToRgb = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const shade = (rgb, f) => rgb.map((c) => Math.round(c * f));
const luminance = ([r, g, b]) => (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
const forDark = (rgb) => (luminance(rgb) < 0.45 ? rgb.map((c) => Math.round(c + (255 - c) * 0.5)) : rgb);

const toHsl = ([r, g, b]) => {
  const [rr, gg, bb] = [r / 255, g / 255, b / 255];
  const max = Math.max(rr, gg, bb), min = Math.min(rr, gg, bb);
  const l = (max + min) / 2;
  let h = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === rr ? (gg - bb) / d + (gg < bb ? 6 : 0) : max === gg ? (bb - rr) / d + 2 : (rr - gg) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

const VARS = ["--genis", "--genis-d", "--genis-l", "--genis-dark", "--genis-deep", "--genis-accent", "--primary", "--primary-d", "--primary-l", "--ring", "--chart-1"];

export const themeVars = (primary, accent) => {
  const p = hexToRgb(primary);
  const l = forDark(p);
  return {
    "--genis": p.join(" "),
    "--genis-d": p.join(" "),
    "--genis-l": l.join(" "),
    "--genis-dark": shade(p, 0.68).join(" "),
    "--genis-deep": shade(p, 0.5).join(" "),
    "--genis-accent": hexToRgb(accent).join(" "),
    "--primary": toHsl(p),
    "--primary-d": toHsl(p),
    "--primary-l": toHsl(l),
    "--ring": toHsl(p),
    "--chart-1": toHsl(p),
  };
};

export const applyTheme = (partner) => {
  const root = document.documentElement;
  VARS.forEach((v) => root.style.removeProperty(v));
  root.dataset.theme = partner ? partner.slug : "genis";
  if (!partner?.primary_color) return;
  Object.entries(themeVars(partner.primary_color, partner.accent_color || partner.primary_color))
    .filter(([k]) => k !== "--genis" && k !== "--primary")
    .forEach(([k, v]) => root.style.setProperty(k, v));
};
